import { IAccount, ICompany } from '@medely/types';

type isSaasAccountInput = Pick<IAccount, 'company'>;
export const isSaasAccount = (account?: isSaasAccountInput) => Boolean(account?.company);

type isSaasCredentialingAndSchedulingAccountInput = isSaasAccountInput & {
  company?: Pick<ICompany, 'saas_scheduling_enabled' | 'saas_credentialing_enabled'>;
};
export const isSaasCredentialingAndSchedulingAccount = (
  account?: isSaasCredentialingAndSchedulingAccountInput,
) =>
  Boolean(account?.company?.saas_scheduling_enabled) &&
  Boolean(account?.company?.saas_credentialing_enabled);

export const isSaasCredentialingAccount = (
  account?: isSaasCredentialingAndSchedulingAccountInput,
) => Boolean(account?.company?.saas_credentialing_enabled);

export const isSaasSchedulingAccount = (account?: isSaasCredentialingAndSchedulingAccountInput) =>
  Boolean(account?.company?.saas_scheduling_enabled);

export const isSaasCredentialingOnlyAccount = (
  account?: isSaasCredentialingAndSchedulingAccountInput,
) => isSaasCredentialingAccount(account) && !isSaasSchedulingAccount(account);

export const isSaasSchedulingOnlyAccount = (
  account?: isSaasCredentialingAndSchedulingAccountInput,
) => isSaasSchedulingAccount(account) && !isSaasCredentialingAccount(account);

export type IsAgencyAccountInput = Pick<IAccount, 'agency_id'> | undefined;
export const isAgencyAccount = (account?: IsAgencyAccountInput) => Boolean(account?.agency_id);

export type isMarketplaceAccountInput = Pick<IAccount, 'company' | 'agency_id'>;
export const isMarketplaceAccount = (account: isMarketplaceAccountInput) =>
  !isAgencyAccount(account) && !isSaasAccount(account);
